<template>
    <ul v-if="flags.loaded" class="nav navbar-nav navbar-left">
        <li>
            <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-content" data-canvas="#wrapper">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
        </li>
        <li v-for="item in nav" :class="item.class" class="hidden-xs">
            <a :href="item.url">
                 <span v-if="item.button" class="btn btn-sm" :class="'btn-' + item.class">{{ item.label}} <i :class="item.icon"></i></span>
                <span v-else>{{ item.label }}</span>
            </a>
        </li>
        <li ref="menu" v-if="user" class="hidden-xs dropdown">
            <a type="button" href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                <span class="great">{{ labels.hello }},</span>
                <b>{{ user.name }}</b>
                <img width="40" height="40" :src="user.avatar" class="img-circle avatar" alt=" " />
            </a>
            <ul class="dropdown-menu dropdown-menu-x">
                <li v-for="(item, index) in menu" :class="item.class">
                    <a :href="item.url"><i :class="item.icon"></i> {{ item.label }}</a>
                </li>
            </ul>
        </li>
        <li v-else class="hidden-xs">
            <a role="button" id="dropdownUserMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" href="#login-form-container">
                <span>{{ $t("session.login") }} | {{ $t("session.register") }}</span>
            </a>
            <div class="dropdown-menu" role="menu" id="login-form-container">

                <form class="login-form" role="form" method="post" action="https://www.neventum.com/login">
                    <h4 class="dark regular mb-20">{{ $t('login.title') }}</h4>

                    <div class="form-group inner-addon right-addon has-feedback">
                        <i class="fa fa-envelope form-control-feedback"></i>
                        <input type="email" class="form-control" :placeholder="$t('login.placeholder_email')" name="email" autofocus="autofocus" value="" required="true" />
                    </div>
                    <div class="form-group inner-addon right-addon has-feedback">
                        <i class="fa fa-lock form-control-feedback"></i>
                        <input type="password" class="form-control" :placeholder="$t('login.placeholder_password')" name="password" value=""  required="true"/>
                    </div>
                    <div class="forget-pass"><a href="/password/reset">{{ $t("login.forget_password") }}</a></div>
                    <button type="submit" class="btn btn-primary btn-block">{{ $t("login.signin") }}</button>
                    <div class="register"><a href="/signup">{{ $t("long.register") }}</a></div>

                </form>

            </div>
        </li>
    </ul>
</template>
<script>

    import User from "../models/User";

    export default {

        name : 'auth',

        data() {
            return {

                user:   null,
                menu:   {},
                labels: {},
                nav:    {},
                flags: {
                    loaded : false,
                }
            }
        },

        props: {
            url : {
                type: String,
                default: 'https://www.neventum.com/check'
            },
        },

        watch : {
        },

        mounted() {

            let self = this;
/*
            if (dataLayer[0].dl_section !== 'undefined') {
                $('#page-item-' + dataLayer[0].dl_section).addClass('active');
            }
*/
            axios.request({
                url : this.url,
                method : "get",
            })
            .then(function (response) {

                if(response.data.length) {

                    self.user   = new User(response.data.user);
                    self.labels = response.data.labels;
                    self.menu   = response.data.menu;
                    self.nav    = response.data.nav;
                }

                self.flags.loaded = true;
            })

            .catch(function (error) {

                console.log(error);
            });
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/auth.vue